const delay = (ms) => new Promise((r) => setTimeout(r, ms));

type FetchParams = {
  url: string;
  options?: Record<string, unknown>;
  retries?: number;
  retryDelay?: number;
};

export const fetchRetry = ({ url, options = {}, retries = 3, retryDelay = 500 }: FetchParams) =>
  fetch(url, options)
    .then(async (res) => {
      if (res.ok) {
        return res;
      }
      if (retries > 0 && res.status === 400) {
        await delay(retryDelay);
        return fetchRetry({ url, retries: retries - 1, retryDelay, options });
      }
      throw new Error(res.statusText);
    })
    .catch((error) => {
      throw error;
    });
